import { Toaster } from 'react-hot-toast'
import styled from 'styled-components'
import LocationImg from './assets/img/luda-location.png'
import { getLayoutConfig } from '@/config/layout.config'
import { EnvironmentBarComponent } from '@/components/environment/environment-bar.component'

const LayoutStyle = styled.section`
  .page-wrapper {
    margin: 0 auto;
  }
  .luda-location-header {
    background: #092240;
  }
  .logo {
    padding: 18px;
    img {
      max-width: 220px;
      max-height: 30px;
    }
  }
  .location-image-wrapper {
    img {
      width: 100%;
      height: auto;
      max-height: 300px;
    }
  }

  .location-page {
    text-align: center;
    color: #040404;
    p {
      font-family: "Poppins";
    }
  }

  .location-title {
    font-size: 18px;
    font-weight: 500;
    line-height: 1.5em;
    margin-bottom: 24px;
  }

  .location-form {
    max-width: 400px;
    margin: 0 auto;
  }

  .location-form-row {
    margin-bottom: 24px;

    &:last-child {
      margin-bottom: 0;
    }

    input {
      border: 2px solid #dadada;
      width: 100%;
      padding: 8px 12px;
      border-radius: 8px;
      outline: none;
      font-size: 16px;
      font-family: "Poppins";
      font-weight: 400;

      &:focus {
        outline: none;
        box-shadow: 0px 4px 8px 0px #0000001a;
      }
    }
  }

  .fake-input {
    background: #eaebef;
    border-radius: 4px;
    padding: 12px;
    p {
      font-weight: 700;
    }
  }

  .other-location {
    p {
      font-weight: 700;
      margin-bottom: 8px;
    }
  }

  .pharmacy-selector {
    p {
      font-weight: 700;
      margin-bottom: 8px;
    }
    width: 100%;
  }

  .location-checkbox-container {
    display: flex;
  }

  .location-checkbox-item {
    margin-right: 12px;
    &:last-child {
      margin-right: 0;
    }
  }

  .legal-row-container {
    max-width: 400px;
    margin: 40px auto;
    text-align: left;
    a {
      color: blue;
      text-decoration: underline;
    }
  }


  .location-title {
    font-size: 16px;
  }

  .other-location {
    p {
      font-size: 16px;
    }
  }

  .location-form,
  .legal-row-container {
    p,
    label {
      font-size: 14px;
    }
  }

  .confirm-row-container {
    max-width: 400px;
    margin: 0 auto;
    text-align: center;
    margin-bottom: 50px;
  }

  @media print {
    .luda-location-header, .location-image-wrapper {
      display: none;
    }
  }
`

interface LayoutProps {
  children: React.ReactNode
}

const config = getLayoutConfig()
document.title = config.title

const favicon = document.querySelector('link[rel="icon"]')
favicon?.setAttribute('href', config.favicon)

export function LayoutComponent ({ children }: LayoutProps): JSX.Element {
  return (
    <LayoutStyle>
      <Toaster
        position='top-right'
      />
      <header className='luda-location-header'>
        <div className='logo'>
          <img src={config.logo} alt='' />
        </div>
      </header>
      <div className='page-wrapper'>
        <section className='location-page'>
          <div className='location-image-wrapper'>
            <img src={LocationImg} alt='' />
          </div>
          {children}
        </section>
      </div>
      <EnvironmentBarComponent />
    </LayoutStyle>
  )
}
